import { BuilderStorageItem } from "./BuilderStorageItem";

export class BuilderStorageItemHistory extends BuilderStorageItem {
    notes: string = "";
}
